import { IReduxAction, IReduxBaseAction } from '@mihanizm56/redux-core-modules';
import { ArraySelectOptionType } from '@wildberries/ui-kit/lib/select/types';
import {
  TConvertedCoefficientsReport,
  TSearchMultiInputOptionsArray,
  TWarehousesLimitsStorage,
} from './types';

const SET_WAREHOUSES = 'supplies-managment-front_warehouses-limits-module_SET_WAREHOUSES';
export const setWarehousesAction: IReduxAction<
  ArraySelectOptionType,
  typeof SET_WAREHOUSES
> = (payload) => ({
  type: SET_WAREHOUSES,
  payload,
});
setWarehousesAction.type = SET_WAREHOUSES;

const SET_COEFFICIENTS_REPORT = 'supplies-managment-front_warehouses-limits-module_SET_COEFFICIENTS_REPORT';
export const setCoefficientsReportAction: IReduxAction<
  TConvertedCoefficientsReport,
  typeof SET_COEFFICIENTS_REPORT
> = (payload) => ({
  type: SET_COEFFICIENTS_REPORT,
  payload,
});
setCoefficientsReportAction.type = SET_COEFFICIENTS_REPORT;

const SET_FILTERED_COEFFICIENTS_REPORT = 'supplies-managment-front_warehouses-limits-module_SET_FILTERED_COEFFICIENTS_REPORT';
export const setFilteredCoefficientsReportAction: IReduxAction<
  TWarehousesLimitsStorage['filteredCoefficientsReport'],
  typeof SET_FILTERED_COEFFICIENTS_REPORT
> = (payload) => ({
  type: SET_FILTERED_COEFFICIENTS_REPORT,
  payload,
});
setFilteredCoefficientsReportAction.type = SET_FILTERED_COEFFICIENTS_REPORT;

const SET_SELECTED_LIMITS_WAREHOUSE_DATE = 'supplies-managment-front_warehouses-limits-module_SET_SELECTED_LIMITS_WAREHOUSE_DATE';
export const setSelectedLimitsWarehouseDateAction: IReduxAction<
  Date,
  typeof SET_SELECTED_LIMITS_WAREHOUSE_DATE
> = (payload) => ({
  type: SET_SELECTED_LIMITS_WAREHOUSE_DATE,
  payload,
});
setSelectedLimitsWarehouseDateAction.type = SET_SELECTED_LIMITS_WAREHOUSE_DATE;

const SET_START_WAREHOUSES_LOADING = 'supplies-managment-front_warehouses-limits-module_SET_START_WAREHOUSES_LOADING';
export const setStartWarehousesLoadingAction: IReduxBaseAction<
  typeof SET_START_WAREHOUSES_LOADING
> = () => ({
  type: SET_START_WAREHOUSES_LOADING,
});
setStartWarehousesLoadingAction.type = SET_START_WAREHOUSES_LOADING;

const SET_STOP_WAREHOUSES_LOADING = 'supplies-managment-front_warehouses-limits-module_SET_STOP_WAREHOUSES_LOADING';
export const setStopWarehousesLoadingAction: IReduxBaseAction<
  typeof SET_STOP_WAREHOUSES_LOADING
> = () => ({
  type: SET_STOP_WAREHOUSES_LOADING,
});
setStopWarehousesLoadingAction.type = SET_STOP_WAREHOUSES_LOADING;

const SET_START_COEFFICIENT_LOADING = 'supplies-managment-front_warehouses-limits-module_SET_START_COEFFICIENT_LOADING';
export const setStartCoefficientsLoadingAction: IReduxBaseAction<
  typeof SET_START_COEFFICIENT_LOADING
> = () => ({
  type: SET_START_COEFFICIENT_LOADING,
});
setStartCoefficientsLoadingAction.type = SET_START_COEFFICIENT_LOADING;

const SET_STOP_COEFFICIENT_LOADING = 'supplies-managment-front_warehouses-limits-module_SET_STOP_COEFFICIENT_LOADING';
export const setStopCoefficientsLoadingAction: IReduxBaseAction<
  typeof SET_STOP_COEFFICIENT_LOADING
> = () => ({
  type: SET_STOP_COEFFICIENT_LOADING,
});
setStopCoefficientsLoadingAction.type = SET_STOP_COEFFICIENT_LOADING;

const SET_FILTERED_WAREHOUSES_ACTION = 'supplies-managment-front_warehouses-limits-module_SET_FILTERED_WAREHOUSES_ACTION';
export const setFilteredWarehousesAction: IReduxAction<
  TSearchMultiInputOptionsArray,
  typeof SET_FILTERED_WAREHOUSES_ACTION
> = (payload) => ({
  type: SET_FILTERED_WAREHOUSES_ACTION,
  payload,
});
setFilteredWarehousesAction.type = SET_FILTERED_WAREHOUSES_ACTION;

const SET_COST_FOR_PALETTE_ACTION = 'supplies-managment-front_warehouses-limits-module_SET_COST_FOR_PALETTE_ACTION';
export const setCostForPaletteAction: IReduxAction<
  number,
  typeof SET_COST_FOR_PALETTE_ACTION
> = (payload) => ({
  type: SET_COST_FOR_PALETTE_ACTION,
  payload,
});
setCostForPaletteAction.type = SET_COST_FOR_PALETTE_ACTION;
